// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { TripHistoryAreaId } from './TripHistoryAreaId'
import {
  TripHistoryAreaNavigation,
  TripHistoryAreaNavigationIcon,
} from './TripHistoryAreaNavigation'
import { TripHistoryAreaRoutes } from './TripHistoryAreaRoutes'

const LazyTripHistoryComponent = lazy(() => import('./TripHistoryArea'))

const TripHistoryComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyTripHistoryComponent />
  </SuspenseLoadingWrapper>
)

export const TripHistoryArea = {
  id: TripHistoryAreaId,
  Icon: TripHistoryAreaNavigationIcon,
  NavigationComponent: TripHistoryAreaNavigation,
  route: {
    path: TripHistoryAreaRoutes.route,
    component: TripHistoryComponent,
  },
}
